<template>
  <!--
    	作者：kmdshop
    	时间：2019-10-25
    	描述：组件-选择API
    -->
  <el-dialog title="选择Api" :visible.sync="dialogVisible" :append-to-body="true" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="900px">
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="API名称">
          <el-input placeholder="请输入API名称" v-model="formInline.name">
            <el-button slot="append" icon="el-icon-search" @click="getData">查询</el-button>
          </el-input>
        </el-form-item>
      </el-form>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="productList" border style="width: 100%" highlight-current-row v-loading="loading" @selection-change="tableCurrentChange">
          <el-table-column width="70" label="logo">
            <template slot-scope="scope">
              <img :src="scope.row.image_url?scope.row.image_url:''" width="30" height="30" />
            </template>
          </el-table-column>
          <el-table-column prop="name" label="名称"></el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 1" class="green">启用</span>
              <span v-if="scope.row.status == 2" class="gray">禁用</span>
            </template>
          </el-table-column>
          <el-table-column label="类型">
            <template  slot-scope="scope">
              <el-tag :type="scope.row.api_type === 0 ? '' : 'danger'">{{
                  scope.row.api_type === 0 ? "开放接口" : "请求接口"
                }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="接口标准">
            <template  slot-scope="scope">
              <span>{{ apiType(scope.row.remark.plugin_name) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" width="140" label="添加时间"></el-table-column>
          <el-table-column type="selection" :selectable="selectableFunc" width="44" v-if="islist"></el-table-column>
          <el-table-column width="80" label="操作" v-if="!islist">
            <template slot-scope="scope">
              <el-button size="mini" v-if="scope.row.noChoose" @click="SingleFunc(scope.row)">选择</el-button>
              <el-button size="mini" v-else disabled>已选</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-sizes="[2, 10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="dialogVisible=false">取 消</el-button>
      <el-button size="small" type="primary" @click="addClerk" v-if="islist">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Api from '@/api/api.js';
export default {
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*当前是第几页*/
      curPage: 1,
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      formInline: {},
      //商品列表
      productList: [],
      multipleSelection: [],
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      dialogVisible: false,
      /*结果类别*/
      type:'error',
      /*传出去的参数*/
      params:'123123',
      /* 接口类型 */
      typeOptions: [],
    };
  },
  props: ['isApi', 'excludeIds','islist'],
  watch:{
    isApi:function(n,o){
      if(n!=o){
        if(n){
          this.dialogVisible=n;
          this.type='error';
          this.params=null;
          this.getData();
        }
      }
    }
  },
  computed: {
    apiType() {
      return value => {
        const optionType =
          this.typeOptions.find(option => option.path === value) || {};
        return optionType.name;
      };
    },
  },
  async created() {
    await this.init();
  },
  methods: {
    /* 初始化数据 */
    async init() {
      await this.getApiType();
    },
    /* 获取类型 */
    async getApiType() {
      try {
        const res = await Api.getApiType();
        this.typeOptions = res.data.list.data;
      } catch (error) {}
    },
    /*是否可以勾选*/
    selectableFunc(e){
      if(typeof e.noChoose !=='boolean'){
        return true;
      }
      return e.noChoose;
    },

    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },

    /*获取商品列表*/
    getData() {
      let self = this;
      let params = self.formInline;
      params.page = self.curPage;
      params.list_rows = self.pageSize;
      Api.getData(params, true)
        .then(res => {
          if (res.code == 1) {
            self.loading = false;
            /*判断是否需要去重*/
            if(self.excludeIds&&typeof(self.excludeIds)!='undefined'&&self.excludeIds.length>0){
              res.data.list.data.forEach(item=>{
                if(self.excludeIds.indexOf(item.api_id)>-1){
                  item.noChoose=false;
                }else{
                  item.noChoose=true;
                }
              });
            }else{
              if(!self.islist){
                res.data.list.data.forEach(item=>{
                  item.noChoose=true;
                });
              }
            }
            self.productList = res.data.list.data;
            self.totalDataNumber = res.data.list.total;
          }
        })
        .catch(error => {});
    },

    /*单选*/
    SingleFunc(row){
      this.multipleSelection=[row];
      this.addClerk();
    },

    //点击确定
    addClerk() {
      let self = this;
      let params = null;
      if (self.multipleSelection.length < 1) {
        self.$message({
          message: '请至少选择一个api！',
          type: 'error'
        });
        return;
      }
      if (self.islist && typeof (self.islist) != 'undefined') {
        self.multipleSelection.forEach(item => {
          if (item.image[0]) {
            item.image = item.image_url;
          }
        });
        params = self.multipleSelection;
      } else {
        params = self.multipleSelection[0];
      }

      self.params = params;
      self.type = 'success';
      self.dialogVisible = false;
    },

    /*关闭弹窗*/
    dialogFormVisible() {
      this.$emit('closeDialog', {
        type: this.type,
        openDialog: false,
        params: this.params
      });
    },

    /*监听复选按钮选中事件*/
    tableCurrentChange(val) {
      this.multipleSelection = val;
    }
  }
};
</script>

<style>
.no-list .el-checkbox{ display: none;}
</style>



// WEBPACK FOOTER //
// src/components/api/App.vue